import jsyaml from 'js-yaml';

export default class ProjectSchemaPresenter {
  constructor(scaffold, schema) {
    if (!schema) {
      throw new Error('schema is required');
    }

    this.configParsed = jsyaml.safeLoad(scaffold.config);
    this.schemaParsed = JSON.parse(schema);
  }

  get runnable() {
    return !!this.configParsed.runnable;
  }

  get properties() {
    let { properties } = this.schemaParsed;
    properties = properties || {};
    const output = [];

    Object.keys(properties).forEach((propertyKey) => {
      const propertyConfig = (this.configParsed
        .properties || {})[propertyKey];
      let value = properties[propertyKey];

      if (!propertyConfig) {
        return;
      }

      if (
        propertyConfig.choices &&
        propertyConfig.choices[value] &&
        propertyConfig.choices[value].label
      ) {
        value = propertyConfig.choices[value].label;
      }

      output.push({
        label: propertyConfig.label,
        value,
      });
    });

    return output;
  }

  get entities() {
    return this.schemaParsed.entities.map((entity) => {
      return {
        label: `${entity.name.singular} (${entity.fields.length})`,
        value: `${entity.fields
          .map((field) => field.name.singular)
          .join(', ')}.`,
      };
    });
  }
}
